/* Copyright 2013 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dijit/_WidgetBase",
    "dijit/_TemplatedMixin",
    "dojo/text!./templates/TabGroup.html",
    "dijit/_Contained",
    "dijit/registry",
    "./_WidgetMixin"
], function (declare, _WidgetBase, _TemplatedMixin, TabGroupHtml, _Contained, registry, _WidgetMixin) {

    return declare([_WidgetBase, _TemplatedMixin, _Contained, _WidgetMixin], {
        /** @lends TabGroup# */

        /**
         * @class TabGroup is a logical widget. It does not have a corresponding presence in the
         * DOM. It facilitates the moving of a group of tabs between Toolstrips.
         */
        templateString: TabGroupHtml,

        constructor: function () {
            this.tabs = [];
        },

        addChild: function (widget, index) {
            var tabCounter = 0, tabIndex = null, toolstrip, i = 0, numTabGroups, tabGroups;

            if (!index && index !== 0) {
                index = this.tabs.length;
            }

            this.tabs.splice(index, 0, widget);

            toolstrip = this.getParent();
            if (toolstrip) {
                tabGroups = toolstrip.getChildren();
                numTabGroups = tabGroups.length;
                while (i < numTabGroups) {
                    if (this === tabGroups[i]) {
                        if (index >= 0) {
                            tabIndex = tabCounter + index;
                        }
                        break;
                    }
                    tabCounter += tabGroups[i].tabs.length;
                    i += 1;
                }
                toolstrip.addTab(widget, tabIndex);
            }
            this.emit("childadded");
        },

        removeChild: function (widget) {
            var toolstrip = this.getParent(), index;
            index = this.tabs.indexOf(widget);
            if (index > -1) {
                this.tabs.splice(index, 1);
            }

            if (this.tabs.length === 0) {
                this.set("selectedTab", "");
            }

            if (toolstrip) {
                toolstrip.removeTab(widget);
            }
            this.emit("childremoved");
        },

        _setSelectedTabAttr: function (tabId) {
            var toolstrip = this.getParent(), tabWidget = registry.byId(tabId);
            if (toolstrip && tabId) {
                toolstrip.selectTab(tabWidget);
                toolstrip.getChildren().forEach(function (tabGroup) {
                    if (tabGroup !== this) {
                        tabGroup.set("selectedTab", "");
                    }
                }, this);
            }
            this._set("selectedTab", tabId);
        }
    });

});